import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { getPlayedStepNumber } from "./playedSteps";
import logo from "../../Assets/images/acoris-logo.svg";
import Progress from "../Progress";
import Actions from "./Actions";

const Navbar = ({
  progress = 0,
  project,
  showCart,
  showHelp,
  showProfile,
  tracer,
  priceLoading,
  step,
  title,
  stepName,
  currentStatus,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const progressValue = progress || currentStatus?.progress || 0;
  const stepNumber =
    step ??
    getPlayedStepNumber({
      currentStatus,
      processStatuses:
        get(tracer, "flow.process.processStatuses") ||
        get(currentStatus, "process.processStatuses") ||
        [],
      project,
    });
  const rawLabel = stepName || title || currentStatus?.name;
  const stepLabel =
    stepNumber && rawLabel
      ? t("NAVBAR.STEP", { step: stepNumber, label: rawLabel })
      : null;

  return (
    <div className="acoris-navbar">
      <div className="acoris-navbar__header">
        <div className="acoris-navbar__logo">
          <img
            src={logo}
            alt="Acoris"
            onClick={() => {
              const acorisSiteWindow = window.open(
                "https://www.acoris-mutuelles.fr/",
                "_blank",
              );
              if (acorisSiteWindow) {
                acorisSiteWindow.opener = null;
              }
            }}
          />
        </div>
        <div className="acoris-navbar__actions">
          <Actions
            project={project}
            showCart={showCart}
            showHelp={showHelp}
            showProfile={showProfile}
            tracer={tracer}
            priceLoading={priceLoading}
          />
        </div>
      </div>
      <Progress value={progressValue} stepLabel={stepLabel} />
    </div>
  );
};

Navbar.propTypes = {};

export default Navbar;
